<template>
  <div class="lightbox">
    <div class="register-window ui-modal--settings mx-auto pt3 pr4 pl4 pb3 border-box box-shadow-big bg-color-darkgray col-12 lightbox-box rounded-border">
      <button class="lightbox-close-btn" @click="closeRegister()">
          <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(45deg);" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 1V23" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M23 12H1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
      </button>
      <div class="flex align-middle mb4" v-if="apiSuccess == '' && registration_status == 0">
        <div>
          <h2 class="h1 color-primary regular">{{$t('register_h_neuen_account_erstellen')}}</h2>
          <h3 class="p color-primary" style="margin-top: -.35rem">{{$t('register_p_kostenlos_unverbindlich')}}</h3>
        </div>
      </div>


      <!-- DEFAULT STATUS -->
      <div class="col-12" v-if="registration_status == 0">
        <p class="h4 mb2">{{$t('register_h_welche_email')}}</p>
        <div>
        <input class="user-input user-input-narrow  col-6 mb2" :placeholder="$t('register_email_placeholder')" v-model="onboardingData.email">
        </div>
        <div>
        <p v-bind:class="{appear : not_filled_email}" class="color-red p hidden">{{$t('register_p_not_filled_email')}}</p>
        <p v-bind:class="{appear : not_correct_email}" class="color-red p hidden">{{$t('register_p_not_correct_email')}}</p>
        </div>
        <div class="pt3">       
          <a class="btn btn-primary" @click="validateEMail()" v-if="apiSuccess == ''">{{$t('register_a_registrieren')}}</a>
        </div>
      </div>

      <!-- E-MAIL ENTERED -->
      <div class="col-12 flex justify-center flex-column" v-if="registration_status == 1 && apiSuccess == ''">

        <!-- Case 0 -->
        <div class="col-12 flex justify-center flex-column" v-if="
                onboardingData.email_known == true && 
                onboardingData.cql_access == true && 
                onboardingData.download_access == true &&
                onboardingData.user_not_validated == false"

        >
          <svg class="mx-auto" width="64" height="64" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 12C8.90111 12 8.80444 12.0293 8.72221 12.0843C8.63999 12.1392 8.5759 12.2173 8.53806 12.3087C8.50022 12.4 8.49032 12.5006 8.50961 12.5975C8.5289 12.6945 8.57652 12.7836 8.64645 12.8536C8.71637 12.9235 8.80546 12.9711 8.90245 12.9904C8.99944 13.0097 9.09998 12.9998 9.19134 12.9619C9.2827 12.9241 9.36079 12.86 9.41573 12.7778C9.47068 12.6956 9.5 12.5989 9.5 12.5C9.5 12.3674 9.44732 12.2402 9.35355 12.1464C9.25979 12.0527 9.13261 12 9 12Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9 10V5" stroke="white" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="white" stroke-miterlimit="10"/>
          </svg>
          <p class="p white pt2 center">{{$t('register_p_konto_vorhanden')}}</p>
          <div class="mx-auto flex align-middle">
            <div>
            <a class="btn btn-primary mt3" @click="closeRegister()">{{$t('register_btn_zurueck_login')}}</a>
            </div>
            <div class="flex align-middle ml3 pt3">
              <p class="p-small regular color-gray">{{$t('register_passwort_vergessen')}}</p>
              <a class="btn btn-ghost-narrow ml3 self-center" @click="openPasswordForm()">{{$t('register_passwort_zuruecksetzen')}}</a>
            </div>
          </div>
        </div>

        <!-- Case 0.1 -->
        <div class="col-12 flex justify-center flex-column" v-if="
                onboardingData.email_known == true && 
                onboardingData.cql_access == true && 
                onboardingData.download_access == true &&
                onboardingData.user_not_validated == true &&
                sendValidationSuccess == false && sendValidationMailError == false"
        >
          <svg class="mx-auto" width="64" height="64" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 12C8.90111 12 8.80444 12.0293 8.72221 12.0843C8.63999 12.1392 8.5759 12.2173 8.53806 12.3087C8.50022 12.4 8.49032 12.5006 8.50961 12.5975C8.5289 12.6945 8.57652 12.7836 8.64645 12.8536C8.71637 12.9235 8.80546 12.9711 8.90245 12.9904C8.99944 13.0097 9.09998 12.9998 9.19134 12.9619C9.2827 12.9241 9.36079 12.86 9.41573 12.7778C9.47068 12.6956 9.5 12.5989 9.5 12.5C9.5 12.3674 9.44732 12.2402 9.35355 12.1464C9.25979 12.0527 9.13261 12 9 12Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9 10V5" stroke="white" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="white" stroke-miterlimit="10"/>
          </svg>
          <p class="p white pt2 center" v-if="!sendValidationSuccess || !sendValidationMailError">{{$t('register_p_infomessage_accountexisting')}}</p>
          <div class="flex align-middle justify-center">
            <div>
              <a class="btn btn-small mt3 mr3" @click="closeRegister()">{{$t('register_btn_zurueck_login')}}</a>
            </div>
            <div v-if="sendValidationSuccess" class="mx2"></div>
            <div>
              <a class="btn btn-small mt3" @click="sendValidationMail()" v-show="!sendValidationSuccess || !sendValidationMailError">{{$t('register_btn_resendconfirmationmail')}}</a>
            </div>
          </div>
        </div>

        <div v-show="sendValidationSuccess" class="col-12 flex justify-center flex-column">
          <svg class="mx-auto" width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.48 6.4492C18.2132 6.25255 17.8792 6.17 17.5516 6.2197C17.2239 6.2694 16.9294 6.44729 16.733 6.7142L10.809 14.7542L7.042 11.7402C6.50174 11.3263 5.72976 11.4203 5.30453 11.9516C4.87929 12.483 4.95681 13.2568 5.479 13.6932L10.262 17.5192C10.529 17.728 10.8687 17.8208 11.2048 17.7766C11.5409 17.7324 11.8451 17.555 12.049 17.2842L18.749 8.1972C18.9453 7.92978 19.0272 7.59531 18.9768 7.26745C18.9263 6.93959 18.7476 6.64523 18.48 6.4492Z" fill="white"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0 12C0 5.37256 5.37259 0 12 0C18.6245 0.00732422 23.9928 5.37549 24 12C24 18.6274 18.6274 24 12 24C5.37259 24 0 18.6274 0 12ZM2 12C2 17.5229 6.47714 22 12 22C17.5203 21.9941 21.9939 17.5205 22 12C22 6.47705 17.5229 2 12 2C6.47714 2 2 6.47705 2 12Z" fill="white"/>
          </svg>
          <p class="h2 white bold mx-auto center pt2">{{$t('register_p_infomessage_secondconfirmationemail')}}</p>
          <p class="h4 color-gray pb4 center">{{$t('register_postfach_pruefen')}}</p>
          <div class="flex justify-center">
            <a class="btn btn-small" @click="closeRegister()">{{$t('register_btn_zurueck_login')}}</a>
          </div>
        </div>

        <div v-show="sendValidationMailError" class="col-12 flex justify-center flex-column">
          <svg class="mx-auto" width="64" height="64" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 12C8.90111 12 8.80444 12.0293 8.72221 12.0843C8.63999 12.1392 8.5759 12.2173 8.53806 12.3087C8.50022 12.4 8.49032 12.5006 8.50961 12.5975C8.5289 12.6945 8.57652 12.7836 8.64645 12.8536C8.71637 12.9235 8.80546 12.9711 8.90245 12.9904C8.99944 13.0097 9.09998 12.9998 9.19134 12.9619C9.2827 12.9241 9.36079 12.86 9.41573 12.7778C9.47068 12.6956 9.5 12.5989 9.5 12.5C9.5 12.3674 9.44732 12.2402 9.35355 12.1464C9.25979 12.0527 9.13261 12 9 12Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9 10V5" stroke="white" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="white" stroke-miterlimit="10"/>
          </svg>
          <p class="h2 white bold mx-auto center pt2 pb4">{{$t('register_p_informessage_mailcouldnotbesend')}}}</p>
          <div class="flex justify-center">
            <a class="btn btn-small" @click="closeRegister()">{{$t('register_btn_zurueck_login')}}</a>
          </div>
        </div>

        <!-- CASE 1  -->
        <div class="col-12" v-if="onboardingData.email_known == false">
          <p class="h4 white mb2">{{$t('register_h_freigeschaltet_geschuetzer_download_bereich')}}</p>
        </div>


        <!-- CASE 2.1 -->
        <div class="col-12 flex flex-column justify-center" v-if="
                onboardingData.email_known == true && 
                onboardingData.cql_access == true && 
                onboardingData.download_access == false && 
                onboardingData.user_imported == false"
        >
          <svg class="mx-auto" width="64" height="64" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 12C8.90111 12 8.80444 12.0293 8.72221 12.0843C8.63999 12.1392 8.5759 12.2173 8.53806 12.3087C8.50022 12.4 8.49032 12.5006 8.50961 12.5975C8.5289 12.6945 8.57652 12.7836 8.64645 12.8536C8.71637 12.9235 8.80546 12.9711 8.90245 12.9904C8.99944 13.0097 9.09998 12.9998 9.19134 12.9619C9.2827 12.9241 9.36079 12.86 9.41573 12.7778C9.47068 12.6956 9.5 12.5989 9.5 12.5C9.5 12.3674 9.44732 12.2402 9.35355 12.1464C9.25979 12.0527 9.13261 12 9 12Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9 10V5" stroke="white" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="white" stroke-miterlimit="10"/>
          </svg>

          <p class="p white pt2 center">{{$t('register_p_zugang_freischalten')}}</p>
          <div class="mx-auto">
            <a class="btn btn-primary mt3 mr3" @click="closeRegister()">{{$t('register_btn_zurueck_zum_cql_login')}}</a>
            <a class="btn btn-primary mt3" @click="activateDownloadAccess()">{{$t('register_btn_zugang_freischalten')}}</a>
          </div>
        </div>

        <!-- CASE 2.2 -->
        <div class="col-12 flex flex-column justify-center" v-if="
              onboardingData.email_known == true && 
              onboardingData.cql_access == false && 
              onboardingData.download_access == true && 
              onboardingData.user_imported == false"
        >
          <svg class="mx-auto" width="64" height="64" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 12C8.90111 12 8.80444 12.0293 8.72221 12.0843C8.63999 12.1392 8.5759 12.2173 8.53806 12.3087C8.50022 12.4 8.49032 12.5006 8.50961 12.5975C8.5289 12.6945 8.57652 12.7836 8.64645 12.8536C8.71637 12.9235 8.80546 12.9711 8.90245 12.9904C8.99944 13.0097 9.09998 12.9998 9.19134 12.9619C9.2827 12.9241 9.36079 12.86 9.41573 12.7778C9.47068 12.6956 9.5 12.5989 9.5 12.5C9.5 12.3674 9.44732 12.2402 9.35355 12.1464C9.25979 12.0527 9.13261 12 9 12Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9 10V5" stroke="white" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="white" stroke-miterlimit="10"/>
          </svg>

          <p class="p white pt2 center">{{$t('register_p_email_bereits_zugang_downloadbereich')}}</p>
          <div class="mx-auto">
            <a class="btn btn-primary mt3" @click="closeRegister()">{{$t('register_btn_zurueck_login')}}</a>
          </div>
        </div>

        <!-- CASE 2.3 -->
        <div class="col-12" v-if="
              onboardingData.email_known == true && 
              onboardingData.cql_access == false && 
              onboardingData.download_access == true &&
              onboardingData.user_imported == true"
        >

          <p class="p white"></p>

        </div>

        <!-- CASE 2.4 -->
        <div  class="col-12" v-if="
              onboardingData.email_known == true && 
              onboardingData.cql_access == false && 
              onboardingData.download_access == false && 
              onboardingData.user_imported == true"
        >


          <p class="p white">{{$t('register_h_freigeschaltet_geschuetzer_download_bereich')}}</p>

        </div>

        <!-- REGISTRATION FORM -->   
        <div v-if="showRegistration == true">
          <p class="col-6 mt3">{{$t('register_p_email')}}</p>
          <p class="h4 mb3" v-bind:class="{ error: not_filled_email}">{{onboardingData.email}}</p>
          <div class="col-12 flex">
            <div class="col-6 pr2">
              <div v-if="unknownData.salutations_id">
                <p class="col-6" v-bind:class="{ error: not_filled_anrede}">{{$t('register_p_anrede')}}</p>
                <div class="relative mb2 user-select-wrapper col-12">
                  <img class="dropdown-arrow" src="../assets/dropdown-arrow.svg">
                  <select id="Anrede" name="Anrede" v-model="onboardingData.salutations_id" class="user-input  user-input-narrow">
                    <option value="0" disabled>{{$t('register_p_anrede')}}</option>
                    <option value="1">{{$t('register_value_herr')}}</option>
                    <option value="2">{{$t('register_value_frau')}}</option>
                  </select> 
                </div>
              </div>
              <div v-if="unknownData.prename">
                <p class="col-6" v-bind:class="{ error: not_filled_vorname}">{{$t('register_form_input_label_prename')}}*</p>
                <input class="user-input  user-input-narrow col-12 mb2" :placeholder="$t('register_form_input_label_prename')" v-model="onboardingData.prename">
              </div>
              <div v-if="unknownData.name">
                <p class="col-6" v-bind:class="{ error: not_filled_nachname}">{{$t('register_form_input_label_surname')}}*</p>
                <input class="user-input  user-input-narrow col-12 mb2" :placeholder="$t('register_form_input_label_surname')" v-model="onboardingData.name">
              </div>
              <div v-if="unknownData.company">
                <p class="col-6" v-bind:class="{ error: not_filled_firma}">{{$t('register_form_input_label_company')}}*</p>
                <input class="user-input  user-input-narrow col-12 mb2" :placeholder="$t('register_form_input_label_company')" v-model="onboardingData.company">
              </div>
              <div v-if="unknownData.tel">
                <p class="col-6" v-bind:class="{ error: not_filled_tel}">{{$t('register_form_input_label_phone')}}*</p>
                <input class="user-input  user-input-narrow col-12 mb2" :placeholder="$t('register_form_input_label_phone')" v-model="onboardingData.tel">
              </div>
            </div>
            <div clas="col-6 pl2">
              <div v-if="unknownData.position">
                <p class="col-6">{{$t('register_form_input_label_position')}}</p>
                <input class="user-input  user-input-narrow col-12 mb2" :placeholder="$t('register_form_input_label_position')" v-model="onboardingData.position">
              </div>
              <div v-if="unknownData.city">
                <p class="col-6" v-bind:class="{ error: not_filled_city}">{{$t('register_form_input_label_city')}}</p>
                <input class="user-input  user-input-narrow col-12 mb2" :placeholder="$t('register_form_input_label_city')" v-model="onboardingData.city">
              </div>
              <div v-if="unknownData.countries_id">
                <p v-bind:class="{ error: not_filled_country}">{{$t('register_p_land')}}</p>
                <div class="relative user-select-wrapper mb1">
                  <img class="dropdown-arrow" src="../assets/dropdown-arrow.svg">
                  <select class="user-input  user-input-narrow col-12 mb1" id="CountrySelect" name="CountrySelect" v-model="onboardingData.countries_id">
                    <option value="0" disabled>{{$t('register_p_land')}}</option>
                    <option v-for="country in countries_list.data" :key="country.id" :value="country.id">
                      {{ country.countryname }}
                    </option>
                  </select> 
                </div>
              </div>
              <div v-if="unknownData.password">
                <p class="col-6" v-bind:class="{ error: not_filled_password}">{{$t('register_form_input_label_password')}}*</p>
                <input type="password" class="user-input  user-input-narrow col-12 mb2" :placeholder="$t('register_form_input_password_placeholder')" v-model="onboardingData.password">
              </div>
              <div v-if="unknownData.password_repeat">
                <p class="col-6" v-bind:class="{ error: not_filled_password_repeat}">{{$t('register_form_input_label_password2')}}*</p>
                <input type="password" class="user-input  user-input-narrow col-12 mb2" :placeholder="$t('register_form_input_password_placeholder')" v-model="onboardingData.password_repeat">
              </div>              
              <div class="flex align-middle mt3" v-if="unknownData.checkdsgvo">
                <input id="dsgvo-register" class="checkbox-input mr2" type="checkbox" v-model="checkdsgvo">
                <label for="dsgvo-register" class="pointer" v-bind:class="{ error: not_filled_checkdsgvo}">{{$t('register_form_input_label_acceptprivacy')}}*</label>
              </div>
            </div>
          </div>

          <div class="col-12 error-msg">
            <label v-bind:class="{ error: !allIsValidated, hidden: allIsValidated}">{{$t('register_p_alle_felder')}}</label>
          </div>
          <div class="col-12 error-msg">
            <label class="error" id="apiError">{{apiError}}</label>
          </div>

          <a class="btn btn-primary mt3" @click="validateReg()">{{$t('register_a_registrieren')}}</a>
        </div>

      </div>

      <div class="col-12 flex justify-center flex-column" v-if="apiSuccess !== ''">
            <svg class="mx-auto" width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.48 6.4492C18.2132 6.25255 17.8792 6.17 17.5516 6.2197C17.2239 6.2694 16.9294 6.44729 16.733 6.7142L10.809 14.7542L7.042 11.7402C6.50174 11.3263 5.72976 11.4203 5.30453 11.9516C4.87929 12.483 4.95681 13.2568 5.479 13.6932L10.262 17.5192C10.529 17.728 10.8687 17.8208 11.2048 17.7766C11.5409 17.7324 11.8451 17.555 12.049 17.2842L18.749 8.1972C18.9453 7.92978 19.0272 7.59531 18.9768 7.26745C18.9263 6.93959 18.7476 6.64523 18.48 6.4492Z" fill="white"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0 12C0 5.37256 5.37259 0 12 0C18.6245 0.00732422 23.9928 5.37549 24 12C24 18.6274 18.6274 24 12 24C5.37259 24 0 18.6274 0 12ZM2 12C2 17.5229 6.47714 22 12 22C17.5203 21.9941 21.9939 17.5205 22 12C22 6.47705 17.5229 2 12 2C6.47714 2 2 6.47705 2 12Z" fill="white"/>
            </svg>
            <p class="h2 white bold mx-auto center pb4 pt2">{{apiSuccess}}</p>
      </div>

      <div v-if="registration_status == 2">
        <p class="p white">{{$t('register_bestaetigen_dsgvo')}}</p>
        <a class="btn btn-primary mt3">{{$t('register_btn_zurueck_zum_cql_login')}}</a>
        <a class="btn btn-primary mt3">{{$t('register_btn_zugang_freischalten')}}
</a>
      </div>




    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { EventBus } from "@/event-bus";

export default {
  data() {
    return {
      registration_status: 0,
      sendValidationSuccess: false,
      sendValidationMailError: false,
      showRegistration: false,
      onboardingData: {
        salutations_id: 0,
        prename: '',
        name: '',
        company: '',
        tel: '',
        position: '',
        email: '',
        city: '',
        countries_id: 0,
        password: '',
        password_repeat: '',
        channel: 'quick-and-light-app-de',
        password_set_by_user: 1,

        email_known: null,
        download_access: null,
        cql_access: null,
        user_imported: null,
        user_not_validated: null
      },
      unknownData: {
        salutations_id: true,
        prename: true,
        name: true,
        company: true,
        tel: true,
        position: true,
        email: true,
        city: true,
        countries_id: true,
        password: true,
        password_repeat: true,
        password_set_by_user: true,
        checkdsgvo: true,
      },
      checkdsgvo: false,
      debug: false,
      not_filled_anrede: false,
      not_filled_vorname: false,
      not_filled_nachname: false,
      not_filled_firma: false,
      not_filled_tel: false,
      not_filled_email: false,
      not_filled_city: false,
      not_filled_country: false,
      not_filled_checkdsgvo: false,
      not_filled_password: false,
      not_filled_password_repeat: false,
      not_same_password: false,
      not_correct_email: false,

      countries_list: [],
      allIsValidated: true,
      apiError: '',
      apiSuccess: ''
    };
  },
  created() {
    axios.get(process.env.VUE_APP_APIENDPOINT + "/public-api/get-countries/json").then(response => (this.countries_list = response.data));

    EventBus.$on('register_old_cql_user', (payload) => {
      console.log('register_old_cql_user received.')
      console.log(payload)
      this.onboardingData.email = payload.email
      this.onboardingData.email_known = true
      this.onboardingData.download_access = false
      this.onboardingData.cql_access = false
      this.onboardingData.user_imported = true
      this.registration_status = 1
      this.showRegistration = true
    })
  }, 
  methods: {

    log: function (obj) {
      if(this.debug) {
        console.log(obj);
      }
    },

    emailValidation(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },

    validateEMail(){
      this.not_correct_email = false;
      this.not_filled_email = false;
      
      var EMail_isValidated = true;
      var answer = this.emailValidation(this.onboardingData.email);
      if(this.onboardingData.email == ''){
        this.not_filled_email = true;
        EMail_isValidated = false;
      }
      if(this.onboardingData.email !== '' && !answer) {
        this.not_correct_email = true;
        EMail_isValidated = false;
      }

      if(EMail_isValidated == true){
        this.registration_status = 1;

        //AXIOS CALL HERE
        let logindata = {};
        logindata.email = this.onboardingData.email;

        let createURL = process.env.VUE_APP_APIENDPOINT + '/register/api/checkemail'
        let currentObj = this; 
        
        axios.post(createURL,logindata).then(function (response) {

          console.log(response.data);
          if(response.data.email_status == "UNKNOWN") {
            console.log('EMAIL STATUS UNKNOWN');
            currentObj.onboardingData.email_known = false;

            currentObj.showRegistration = true;
          }
          if(response.data.email_status == "USER_HAS_TO_ACCEPT_QAL_RULES"){
            console.log('EMAIL STATUS USER_HAS_TO_ACCEPT_QAL_RULES');
            currentObj.onboardingData.email_known = true;
            currentObj.onboardingData.cql_access = false;
            currentObj.onboardingData.download_access = true;
            currentObj.onboardingData.user_imported = false; 

            // currentObj.showRegistration = true;
          }
          if(response.data.email_status == "USER_FULLY_REGISTERED_ALL_FINE"){
            console.log('USER_FULLY_REGISTERED_ALL_FINE');
            currentObj.onboardingData.email_known = true;
            currentObj.onboardingData.cql_access = true;
            currentObj.onboardingData.download_access = true;
            currentObj.onboardingData.user_not_validated = false;

          }
          if(response.data.email_status == "USER_FULLY_REGISTERED_BUT_NOT_ACTIVE"){
            console.log('USER_FULLY_REGISTERED_BUT_NOT_ACTIVE');
            currentObj.onboardingData.email_known = true;
            currentObj.onboardingData.cql_access = true;
            currentObj.onboardingData.download_access = true;
            currentObj.onboardingData.user_not_validated = true;

          }             
        })
        .catch(function () {
          currentObj.log('catch Function of AJAX-Called... error validateEMail()');
    
        });

      }
    },




    validateReg(){


      this.allIsValidated = true;

      if(this.onboardingData.salutations_id == '') {
        this.not_filled_anrede = true;
        this.allIsValidated = false;
      }
      if(this.onboardingData.prename == '') {
        this.not_filled_vorname = true;
        this.allIsValidated = false;
      }
      if(this.onboardingData.name == '') {
        this.not_filled_nachname = true;
        this.allIsValidated = false;
      }
      if(this.onboardingData.company == '') {
        this.not_filled_firma = true;
        this.allIsValidated = false;
      }
      if(this.onboardingData.tel == '') {
        this.not_filled_tel = true;
        this.allIsValidated = false;
      }
      if(this.onboardingData.password == '') {
        this.not_filled_password = true;
        this.allIsValidated = false;
      }
      if(this.onboardingData.password_repeat == '') {
        this.not_filled_password_repeat = true;
        this.allIsValidated = false;
      } else {
        if(this.onboardingData.password_repeat != this.onboardingData.password) {
          this.not_same_password = true;
          this.allIsValidated = false;
        }
      }
      if(this.checkdsgvo == false) {
        this.not_filled_checkdsgvo = true;
        this.allIsValidated = false;
      }

      let createURL = process.env.VUE_APP_APIENDPOINT +  '/register/api/do'

      let currentObj = this;

      let formData = JSON.stringify(this.onboardingData);

      if(this.allIsValidated) {
        axios.post(createURL, formData).then(function (response) {

          if(response.data.success == 1){
            currentObj.apiSuccess = response.data.message
          }else{
            currentObj.apiError = response.data.message
          }

          currentObj.apiResponse = response.data;
          currentObj.log('Then Function of AJAX-Called... called()');
          currentObj.log(currentObj.apiResponse);
         
        })
        .catch(function (error) {
          currentObj.log('catch Function of AJAX-Called... error()');
          currentObj.log(error);
          currentObj.apiResponse = error;

        });
      }
    },

    activateDownloadAccess(){
      console.log('DOWNLOAD ACCESS HERE')
    },

    closeRegister(){
      this.registration_status = 0;
      this.sendValidationSuccess = false;
      this.sendValidationMailError = false;
      this.apiSuccess = '';
      this.showRegistration = false;
      this.onboardingData.email = '';
      this.onboardingData.email_known = null;
      this.onboardingData.cql_access = null;
      this.onboardingData.download_access = null;
      this.onboardingData.user_imported = null;

      this.not_filled_email = false;
      this.not_filled_nachname = false;
      this.not_filled_firma = false;
      this.not_filled_tel = false;
      this.not_filled_city = false;
      this.not_filled_country = false;
      this.not_filled_checkdsgvo = false;
      this.not_filled_password = false;
      this.not_filled_password_repeat = false;
      this.not_same_password = false;
      this.not_filled_anrede = false;
      this.not_filled_vorname = false;
      this.not_correct_email = false;
      EventBus.$emit('closeRegister');
    },
    openPasswordForm(){
      this.closeRegister()
      EventBus.$emit('closeRegisterOpenPw')
    },
    sendValidationMail(){

      let useremail = {};
      useremail.email = this.onboardingData.email;
      useremail.channel = "quick-and-light-app-de"

      let createURL = process.env.VUE_APP_APIENDPOINT + '/register/api/sendemailagain'

      axios.post(createURL, useremail)
      .then(response => {
        console.log(response)
        if(response.data.success == 1){
          this.sendValidationSuccess = true
          this.sendValidationMailError = false
        }else{
          this.sendValidationSuccess = false
          this.sendValidationMailError = true
        }
      })
      .catch(function (error) {
        console.log(error)
      });
    }

  },

};
</script>
<style>

</style>
